import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-dashboard',
  templateUrl: './mcommerce-virtual-cash-register-dashboard.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-dashboard.component.scss']
})
export class McommerceVirtualCashRegisterDashboardComponent implements OnInit {

  cashes;

  constructor() {
    this.cashes = [
      { id: '000112358132', enabled: true, qr: '000112358132', name: 'cash 1', customer: 'Fernando García', amount: '52,68' },
      { id: '000442623836', enabled: true, qr: '000442623836', name: 'cash 2', customer: 'John DOE', amount: '2,12' },
      { id: '000322356136', enabled: false, qr: '000112358132', name: 'cash 3', customer: 'Javier Suárez', amount: '33,1' },
      { id: '320142358132', enabled: true, qr: '000112358132', name: 'cash 4', customer: 'Romeo Santos', amount: '101,95' } ];
  }

  ngOnInit() {
  }

}
